import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';
import { POPUP_WIDTH } from '../../const';

export const useStyles = makeStyles(
  (theme) => ({
    tabs: {
      color: COLORS.primary.default,
      borderBottom: `1px solid ${COLORS.primary.light}`,
      margin: theme.spacing(1.25, -3.75, 2, -3.75),
      width: POPUP_WIDTH,
    },
    indicator: {
      height: '2px',
    },
    tab: {
      width: '50%',
      padding: theme.spacing(1.5, 2.25, 0.88),
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.neutral.darkGray,

      '& + &': {
        marginLeft: theme.spacing(0),
        pointerEvents: 'auto',
      },

      '&$selected': {
        color: COLORS.primary.active,
      },
    },
    selected: {},
    customTab: {
      display: 'flex',
      alignItems: 'center',
    },
    diamond: {
      marginRight: theme.spacing(1),
      width: 24,
      height: 24,
    },
  }),
  {
    name: 'DatasetTabs',
  }
);
